import { AppstoreAddOutlined } from '@ant-design/icons';
import { Avatar, Button, Dropdown, Input, List, Menu, Skeleton } from 'antd';
import { memo, useCallback, useContext, useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AuthContext } from '../../contexts/AuthContext';
import { ConversationContext } from '../../contexts/ConversationContext';
import { UserContext } from '../../contexts/UserContext';
import { colorPlaceholderAvatar, shuffle } from '../../utils/constants';
import CreateGroupMemberForm from '../kits/CreateGroupMemberForm';

const { Search } = Input;

const UserTab = () => {
  const {
    authState: { user },
  } = useContext(AuthContext);
  const {
    deleteUser,
    getUsers,
    userState: { users, pagination },
  } = useContext(UserContext);
  const { sendNewMessage } = useContext(ConversationContext);
  const [loading, setLoading] = useState(false);
  const [openModalCreate, setOpenModalCreate] = useState(false);
  const [array, setArray] = useState([]);

  useEffect(() => {
    const getApi = async () => {
      await Promise.all([getUsers()]);
      setArray(shuffle(colorPlaceholderAvatar));
    };
    getApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadMoreData = useCallback(async () => {
    console.log('loadMoreData user');
    if (loading) {
      return;
    }
    setLoading(true);
    getUsers()
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [getUsers, loading]);

  // useEffect(() => {
  //   loadMoreData();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  const onSearch = useCallback((value) => {
    console.log(value);
  }, []);

  const onDeleteClick = useCallback(
    (id) => {
      deleteUser(id);
    },
    [deleteUser]
  );

  const sayHiClick = useCallback(
    (userId) => {
      sendNewMessage({ message: 'Hi 😘', userId });
    },
    [sendNewMessage]
  );

  const handleCancelModalCreate = useCallback(() => {
    setOpenModalCreate(false);
  }, []);

  return (
    <>
      <div
        style={{
          background: '#001529',
          display: 'flex',
          position: 'sticky',
          alignItems: 'center',
          padding: '16px 0px',
          zIndex: 2,
          top: 38,
        }}
      >
        <Search
          className="logo"
          placeholder="Search user"
          allowClear
          onSearch={onSearch}
        />
      </div>
      {user?.role !== 'USER' && (
        <Button
          block
          icon={<AppstoreAddOutlined />}
          ghost
          onClick={() => setOpenModalCreate(true)}
        >
          Create group chat
        </Button>
      )}
      <CreateGroupMemberForm
        openModalCreate={openModalCreate}
        handleCancelModalCreate={handleCancelModalCreate}
        users={users}
        userId={user?.id}
      />

      <InfiniteScroll
        dataLength={users?.length}
        next={loadMoreData}
        hasMore={pagination?.page < pagination?.totalPages}
        loader={
          <Skeleton
            avatar
            paragraph={{ rows: 0 }}
            active
            style={{ margin: '0px 20px' }}
          />
        }
        // endMessage={<Divider plain>🤐</Divider>}
        scrollableTarget="scrollableDiv"
      >
        <List
          dataSource={users}
          renderItem={(item, index) => (
            <List.Item key={item?.id}>
              <List.Item.Meta
                style={{
                  margin: '0px 20px',
                  alignItems: 'center',
                }}
                avatar={
                  <Avatar
                    style={{
                      backgroundColor:
                        array[
                          index -
                            array.length * Math.floor(index / array.length)
                        ],
                    }}
                    size="large"
                    src={item?.avatar}
                  >
                    {item?.fullName
                      ?.match(/\b(\w)/g)
                      ?.join('')
                      ?.substring(0, 2)}
                  </Avatar>
                }
                title={
                  <strong
                    style={
                      item?.isActivated
                        ? { color: 'rgba(255, 255, 255, 0.65)' }
                        : { color: '#ff000080', textDecoration: 'line-through' }
                    }
                  >
                    {item?.fullName}
                  </strong>
                }
                description={
                  <small style={{ color: 'rgba(255, 255, 255, 0.65)' }}>
                    {item?.email}
                  </small>
                }
              />
              {user?.id !== item?.id && item?.isActivated && (
                <Dropdown.Button
                  danger
                  ghost="true"
                  size="small"
                  style={{
                    marginRight: '10px',
                  }}
                  overlay={
                    <Menu
                      onClick={(e) => {
                        if (e?.key === '2') {
                          onDeleteClick(item?.id);
                        } else if (e?.key === '1') {
                          sayHiClick(item?.id);
                        }
                      }}
                      items={[
                        {
                          key: '1',
                          label: 'Say hi 😘',
                        },
                        user?.role === 'ADMIN' && item?.role !== 'ADMIN'
                          ? {
                              key: '2',
                              label: 'Delete user',
                            }
                          : null,
                      ]}
                    />
                  }
                />
              )}
            </List.Item>
          )}
        />
      </InfiniteScroll>
    </>
  );
};

export default memo(UserTab);
